<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                      <li class="tit_150">Subsidiary</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select id="selectRhqCd1" name="selectRhqCd1" v-model="selectRhqCd" @change="changeRhqCd($event)" class="slt_white w100">
                                <!-- <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option> -->
                                <option v-for="(item, index) in rhqCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqCd ? (item.code == selectRhqCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select id="selectRhqSubCd1" name="selectRhqSubCd1" v-model="selectRhqSubCd" @change="changeRhqSubCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqSubCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqSubCd ? (item.code == selectRhqSubCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                                    
                    <ul class="w50">
                      <li class="tit_150">Content Type</li>
                      <li data-input-type="select" class="w100-150">
                        <select id="selectContentType" name="selectContentType" v-model="selectContentType" class="slt_white w100">
                            <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                            <option VALUE='SM'>Service Manual</option>
                            <option VALUE='KSML'>Local Service Manual</option>
                            <option VALUE='EV'>Exploded View</option>
                            <option VALUE='SB'>Service Bulletin</option>
                            <option VALUE='KSBL'>Local Service Bulletin</option>
                            <option VALUE='IG'>Install Guide</option>
                            <option VALUE='TM'>Training Manual</option>
                            <option VALUE='KTTM'>Technical Training Manual</option>
                            <option VALUE='KATM'>Agent Technical Manual</option>
                            <option VALUE='RT'>Repair Tip</option>
                            <option VALUE='KRRT'>Repeated Repair Tip</option>
                            <option VALUE='KRTT'>Local Repair Tip</option>
                            <option VALUE='DR'>Driver</option>
                            <option VALUE='FM'>Firmware</option>
                            <option VALUE='SW'>Software</option>
                            <option VALUE='UM'>User Manual</option>
                            <option VALUE='EM'>Quick Guide</option>
                            <option VALUE='AT'>Agent Tip</option>
                            <option VALUE='KAGT'>Local Agent Tip</option>
                            <option VALUE='CS'>Consult Script</option>
                        </select>
                      </li>
                    </ul>
                    <ul class="w100">
                      <li class="tit_150">Category</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select class="slt_white w100p" id="PRD_CATEGORY_CD1" v-model="PRD_CATEGORY_CD1" @change="changeCategory1($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList1.length > 0" v-for="item in categoryComboList1" :key="item.code" :value="item.code">{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p" id="PRD_CATEGORY_CD2" v-model="PRD_CATEGORY_CD2" @change="changeCategory2($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList2.length > 0" v-for="item in categoryComboList2" :key="item.code" :value="item.code" >{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p" id="PRD_CATEGORY_CD3" v-model="PRD_CATEGORY_CD3" @change="changeCategory3($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList3.length > 0" v-for="item in categoryComboList3" :key="item.code" :value="item.code" >{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">{{$t('FIELD.GLOBAL.PERIOD')}} <em class="txt_mandatory">*</em></li>
                        <li data-input-type="date" class="w100-150">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" placeholder="" @blur="refineColumns()" class="date_input w100p" readonly>
                                        <a href="javascript:" id="icoToDate" class="in_btn">
                                            <i class="ico_date"></i>
                                            <span class="sr_only"></span>
                                        </a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;" />
                                </span>
                            </fieldset>
                        </li>
                    </ul>         
                   
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="onSearch()">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <div class="grid_wrap number-cell">
                    <!-- Count -->
                <!-- <div class="grid_total">
                    Total&nbsp;Count&nbsp;
                    <em>{{ totalCount | numberFormat }}</em>
                </div> -->
                <div class="btn_wrap">
                    <a
                            href="javascript:"
                            class="btn_white"
                            @click="excelDownload()"
                            title
                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
               <toast-grid
                    :gridId="gridId"
                    :data="gridData"
                    ref="GridId"
                    :columns="columns"
                    :options="options"
                    :header="gridHeader"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                />
            </div>

            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import qs                       from 'query-string';
import api                      from '@/service';
import axios                    from 'axios';
import moment                   from 'moment';
import constants                from '@/constants';
import { SDLUtil, DateUtil }    from '@/utils';
import SKPBreadcrumbs           from '~vb/main/SKPBreadcrumbs';
import DatePicker               from '~c/DatePicker';
import ToastGrid                from '~c/ToastGrid';
import ExcelDownloadPopup       from '~vb/common/ExcelDownloadPopup';
import { EventBus } from '@/utils/EventBus';

require('moment-jdateformatparser');

// 메인 목록 조회
const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/getMonthlySatisfactions.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ToastGrid Tooltip renderer
class TooltipRenderer {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        el.innerText = resVal;
        el.title = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

export default {
    name : 'UnreadList',
    props : {

    },
    data() {
        return {
            isProcess: true,
            selectRhqCd: '',
            selectRhqSubCd: '',
            rhqCd: '',
            corpNo: '',
            prodCateCd1: '',
            prodCateCd2: '',
            prodCateCd3: '',
            TO_DATE: {},       // End Date
            rhqCdList: [],
            rhqSubCdList: [],
            corpNoList: [],
            selectContentType:'',
            prodCategories1: [],
            prodCategories2: [],
            prodCategories3: [],
            PRD_CATEGORY_CD1: '',   // Category 1
            PRD_CATEGORY_CD2: '',   // Category 2
            PRD_CATEGORY_CD3: '',   // Category 3
            categoryComboList1: [], // Category 1 List
            categoryComboList2: [], // Category 2 List
            categoryComboList3: [], // Category 3 List
            searchParam: {},
            
            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "GridId",
            gridKey: 0,
            gridData : [],
            columns : [],
            gridHeader: {},
            options : {
                scrollX: false,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            params:     'getParams',
            locale:     'getLocale',
            menus:      'getMenus',
            loginNo:    'getLoginNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        },
    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        categoryClear(){
            this.setCategory1();
            this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
            this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
        },
        async getCodeComboList(categoryVal, categoryCode) {
            let corpCd = this.selectRhqSubCd == "" ? this.getUserCorpCd : this.selectRhqSubCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, corpCd);
            return codeResp;
        },
        async getCodeComboList1(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.rhqSubCdList = [], this.selectRhqSubCd = '';

            } else {
                this.getCodeComboList1(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = '';
                });
            }
            this.categoryClear();
        },
        // 법인 코드 변경 이벤트
        changeRhqSubCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.selectRhqSubCd = '';
                this.selectRhqSubNm = '';
            } else {
                this.selectRhqSubCd = this.getComboBoxVal(e.target.id);
                this.selectRhqSubNm = this.getComboBoxName(e.target.id);
            }
            this.categoryClear();
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.PRD_CATEGORY_CD1 = "";
                this.categoryComboList1 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1() {
            if(this.PRD_CATEGORY_CD1 == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD1, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2() {
            if(this.PRD_CATEGORY_CD2 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD2, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // 세번째 카테고리 변경 이벤트
        async changeCategory3() {
            if(this.PRD_CATEGORY_CD3 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },

        // 권한체크
        isAllUser(){
            
            if(this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`) || 
               this.getUserRole.includes(`${constants.GBM_ADMIN}`) ||
               this.getUserRole.includes(`${constants.RHQ_ADMIN}`)) 
            {
                return true;
            }else{
                return false;
            }
            
        },
        getSearchParams() {
            let params = {
                RHQCD               : this.selectRhqCd,
                RHQSUBCD            : this.selectRhqSubCd,
                CONTENTTYPE         : this.selectContentType,
                PRD_CATEGORY_CD1    : this.PRD_CATEGORY_CD1,
                PRD_CATEGORY_CD2    : this.PRD_CATEGORY_CD2,
                PRD_CATEGORY_CD3    : this.PRD_CATEGORY_CD3,
                TOMONTH : this.TO_DATE.getDate() ? moment(this.TO_DATE.getDate()).formatWithJDF(moment().toMomentFormatString('yyyyMM')) : ''
            };
            let columnIds = [];
            let columnNames = [];
            let columnAligns = [];
            this.columns.forEach(elm => {
                columnIds.push(elm.name);
                columnNames.push(elm.header.replace(/\'/g, '20'));
                columnAligns.push((elm.align || 'L').replace('center', 'C'));
            });
            params.columnIds    = columnIds;
            params.columnNames  = columnNames;
            params.columnAligns = columnAligns;
            return params;
        },

        // 버튼 이벤트
        async onSearch() {
//            let validContents = this.registVerifyContents();
            let params = this.getSearchParams();
            params.queryId = 'selectMonthlyContentsSatisfactions';
            console.log('params ==> ', params);
            SDLUtil.showLoadingBar(true);
            const response = await fetchGridData(params)
                .then(res => {
                    console.log('Search.resp ==> ', res);
                    this.gridData = res.data.rows;
                    console.log('this.gridData ==> ', this.gridData);
                    this.totalCount = res.data.totalCount;
                    this.searchParam = res.data.searchParam;

                    this.$nextTick(() => {
                        this.$refs.GridId.addRowClassName(this.totalCount-1, 'subTotal');
                        this.gridData.forEach((row, idx) => {
                            if (row.CONTENT_NM_CONV.indexOf('Average') > -1) {
                                this.$refs.GridId.addRowClassName(idx, 'subTotal');
                            }
                        });
                    });

                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
            });
        },
        
        // 엑셀 다운로드
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    let param = this.getSearchParams();
                    param.excelFileName = 'MonthlyContentsSatisfaction';
                    param.dynQueryId    = 'selectMonthlyContentsSatisfactions';

                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/monthlyQnaCommonsExcel.skp`,
                            qs.stringify(param),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        // 그리드 컬럼 재정의
        refineColumns() {
            let toMonth = this.TO_DATE.getDate() ? moment(this.TO_DATE.getDate()).formatWithJDF(moment().toMomentFormatString('yyyyMM')) : '';
            console.log('toMonth ==> ', toMonth);
            let year1 = toMonth.substring(0, 4);
            let year0 = String(Number(year1) - 1);

            this.gridData = [];
            let cntWid = 100;

            let colNames = [];
            let monAft = 12;
            for (let i=0; i<13; i++) {
                if (String(monAft).length == 1 ) {
                    monAft = '0' + monAft;
                }
                colNames.push('MON_' + monAft);
                monAft = Number(monAft) - 1;
            }
            this.gridHeader = {
                height: 60,
                complexColumns: [
                    {
                        header: 'Year',
                        name: 'mergeColumn1',
                        childNames: ['YEAR_1', 'YEAR_0']
                    },
                    {
                        header: 'Month',
                        name: 'mergeColumn2',
                        childNames: colNames
                    },
                ]
            };

            // Base columns
            this.columns = [
                {
                    header: "Content",
                    name: "CONTENT_NM_CONV",
                    renderer: {type: TooltipRenderer },
                    sortable: false,
                    resizable: true
                },
                {
                    header: year1,
                    name: "YEAR_1",
                    align: 'center',
                    sortable: false,
                    resizable: true
                },
                {
                    header: year0,
                    name: "YEAR_0",
                    align: 'center',
                    sortable: false,
                    resizable: true
                }
            ];

            let year2 = Number(year0.substring(2, 4));
            let mon = Number(toMonth.substring(4, 6));
            for (let i=0; i<13; i++) {
                if (String(mon).length == 1 ) {
                    mon = '0' + mon;
                }
                let header = '\'' + year2 + '.' + mon;
                let col = {
                    header: header,
                    name: colNames[i],
                    width: 55,
                    align: 'center',
                    sortable: false,
                    resizable: true
                }
                this.columns.push(col);

                mon = Number(mon) + 1;
                if (mon > 12) {
                    year2 = Number(year2) + 1;
                    mon = 1;
                }
            }
//            EventBus.$emit('grid-search');
//            EventBus.$emit('grid-set-column');

//            EventBus.$emit('grid-refresh');
            this.gridKey += 1;
        },
        registVerifyContents() {
            let validList = [''];
            if (SDLUtil.isNull(this.TO_DATE.getDate())) validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if (validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        }
    },
/*    
    watch: {
        toMonth () {
            console.log('toMonth ===> ', this.toMonth);;
        }
    },
*/    
    created() {
        // 초기 카테고리1 리스트 로드
        this.setCategory1();
    },
    mounted() {
        this.$nextTick(() => {
            this.getCodeComboList1(this.getLoginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data;
                    this.selectRhqCd =  this.getLoginRHQCd;
                });

            this.getCodeComboList1(this.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = this.getLoginCompanyCd;
                });

            let toDate = new Date();    
            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', { type: 'month'} , new Date());
            setTimeout(() => { this.refineColumns(); }, 500);

        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
.zindex9999 { z-index: 99999999; }
.ftColor { color: dodgerblue!important; font-weight: bold!important; cursor:pointer; }
.ftBold {font-weight: bold!important;}
.subTotal {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/monthlyContentsSatisfactionList.vue